import { getInstagramMediasLinksCount } from '../api/linksApi';
import { MAX_LINKS_COUNT_FETCH } from '../../constants';

export const buildMap = (obj) => Object.keys(obj).map((k) => [k, obj[k]]);

export const splitAndSlice = (
  str,
  start = 0,
  end = MAX_LINKS_COUNT_FETCH * 2,
) => str.split(',').slice(start, end).join(',');

export const createLinksPromiseArray = (
  isMultipleCalls,
  mediasIds,
  mediasLinks,
  isTemplate,
  templateId,
) => {
  let promisesArray;

  if (isMultipleCalls) {
    const mediaIdsFirst = splitAndSlice(mediasIds, 0, MAX_LINKS_COUNT_FETCH);
    const mediaIdsSecond = splitAndSlice(mediasIds, MAX_LINKS_COUNT_FETCH);
    const mediaLinksFirst = splitAndSlice(
      mediasLinks,
      0,
      MAX_LINKS_COUNT_FETCH,
    );
    const mediaLinksSecond = splitAndSlice(mediasLinks, MAX_LINKS_COUNT_FETCH);
    promisesArray = [
      getInstagramMediasLinksCount(
        mediaIdsFirst,
        mediaLinksFirst,
        isTemplate,
        templateId,
      ),
      getInstagramMediasLinksCount(
        mediaIdsSecond,
        mediaLinksSecond,
        isTemplate,
        templateId,
      ),
    ];
  } else {
    promisesArray = [
      getInstagramMediasLinksCount(
        mediasIds,
        mediasLinks,
        isTemplate,
        templateId,
      ),
    ];
  }

  return promisesArray;
};
